import type { ReactNode } from 'react'

import { Flex, Text } from '@enechain/ecloud-designsystem'

type PageBodyProps = {
  /**
   * ページ本体の見出し。textStyle="sectionTitle" で固定描画 (ReactNode 不可 = 型で
   * typography 手書きの抜け道を塞ぐ)。省略時は見出し行を描画しない。
   */
  heading?: string
  /**
   * 固定領域 (サマリーカード / DetailHeader / FilterToolbar 等) と PageScrollArea を
   * caller が並べる順に縦に並べる。フィルタ行 (FilterToolbar) も含め、置く位置は本
   * component が決めず children 内の任意位置に置く。縦 spacing は本 component の
   * gap 16px 固定が一意に決めるため、順序は caller の design 準拠順に従えばよい。
   */
  children: ReactNode
}

/**
 * ページ本体の縦積み骨格 (frontend-design-unification 設計書 §5.1)。
 * ルート flex column + height 100% + overflow hidden + 縦 gap 16px 固定 (prop 化しない)。
 * PageLayout の children 直下に置くこと (高さが伝播しないコンテキストでは潰れる)。
 */
export const PageBody = ({
  heading,
  children,
}: PageBodyProps): React.ReactElement => (
  <Flex flexDirection="column" gap={4} overflow="hidden" height="100%">
    {heading !== undefined && <Text textStyle="sectionTitle">{heading}</Text>}
    {children}
  </Flex>
)
